// TODO remove backwards-compatibility config

import parse from 'url-parse';
import qs from 'query-string';
import { getTransactionAnalytics } from '@ynap/analytics';

export function trackLoginSuccess() {
    return {
        event: 'sign in - successful',
        eventEffect: 'sign in successful',
    };
}

export function trackLoginError({ errorMessage }) {
    return {
        event: 'sign in - error',
        eventEffect: 'user experienced error',
        attributes: {
            errorMessage,
        },
    };
}

export function trackRegistrationSuccess(maMarketingConsent, hasRewards = false) {
    return {
        event: 'sign_up',
        marketing_preferences: maMarketingConsent,
        ...(hasRewards && { rewards_preference: 'true' }),
    };
}

export function trackRegistrationOptIn(maMarketingConsent) {
    return {
        event: 'opt_in',
        opt_position: "sign up",
        opt_value: JSON.parse(maMarketingConsent)
    };
}

export function trackRegistrationError({ errorMessage }) {
    return {
        event: 'registration - error',
        eventEffect: 'user experienced error',
        attributes: {
            errorMessage,
        },
    };
}

export function trackOptIn(marketingConsentValue = false) {
    return {
        event: 'opt_in',
        opt_position: 'confirmation page',
        opt_value: marketingConsentValue
    };
}

// this won't be needed once this has been refactored to use @ynap/analytics
const removeQueryParams = (urlString, fields = ['email']) => {
    const parsed = parse(urlString, true);
    fields.forEach((field) => {
        delete parsed.query[field];
    });
    // url-parse adds localhost as the hostname to relative urls so we address that here
    const isNotRelative = parsed.hostname !== 'localhost' && parsed.hostname !== '';
    const queryParams = Object.keys(parsed.query).length > 0 ? `?${qs.stringify(parsed.query)}` : '';

    return isNotRelative ? parsed.toString() : `${parsed.pathname}${queryParams}`;
};

export function pageData({ name, type, subCategory1 }) {
    return function (props) {
        if (typeof window !== 'undefined') {
            const { hostname, pathname } = window.location;
            const { locale, config } = props;

            let environment = 'dev';
            const business = (config.head?.business || config.business).toLowerCase();

            if (
                (business === 'mrp' && hostname === 'www.mrporter.com') ||
                (business === 'nap' && hostname === 'www.net-a-porter.com') ||
                (business === 'ton' && hostname === 'www.theoutnet.com')
            ) {
                environment = 'prod';
            }

            const data = {
                event: 'trackPage',
                page: {
                    pageInfo: {
                        pageName: name,
                        environment,
                        geoRegion: locale.country,
                        language: locale.language,
                        destinationURL: removeQueryParams(pathname),
                        referringURL: removeQueryParams(document.referrer),
                        sysEnv: 'website',
                        variant: 'default',
                    },
                    category: {
                        pageType: type,
                        subCategory1,
                    },
                    attributes: {
                        businessName: business,
                        region: locale.region,
                        featuresList: [],
                        currencyCode: undefined,
                    },
                },
            };

            return data;
        }
    };
}

export const trackReadPrivacyPolicy = ({ checkoutAnalytics } = {}) => {
    return {
        event: 'read privacy policy',
        effect: 'read policy',
        ...(checkoutAnalytics && { transaction: getTransactionAnalytics(checkoutAnalytics) }),
    };
};

export const trackReadTermsAndConditions = () => {
    return {
        event: 'read terms and condition',
        effect: 'read policy',
    };
};

export const trackAgreeTerms = () => {
    return {
        event: `changes on our site - agree`,
        effect: 'login',
    };
};

export const trackDisagreeTerms = () => {
    return {
        event: 'changes on our site - dont agree',
        effect: 'login',
    };
};

export const trackForgotPassword = ({ checkoutAnalytics } = {}) => ({
    event: 'forgotten password',
    eventEffect: 'submit',
    ...(checkoutAnalytics && { transaction: getTransactionAnalytics(checkoutAnalytics) }),
});

export const trackLoginOptions = (hasAccount) => ({
    event: hasAccount ? 'I have an account' : 'I want to register for an account',
    eventEffect: 'radio button',
});

export const trackCheckoutLoginOptions = (formType, checkoutAnalytics) => ({
    event: {
        login: 'I have an account',
        registration: 'I want to register for an account',
        guest: 'I want to checkout as a guest',
    }[formType],
    eventEffect: 'radio button',
    ...(checkoutAnalytics && { transaction: getTransactionAnalytics(checkoutAnalytics) }),
});

export const trackMarketingConsent = (consent, checkoutAnalytics) => ({
    event: consent ? 'yes sign me up for email updates' : 'no dont sign me up for email updates',
    eventEffect: 'radio button',
    ...(checkoutAnalytics && { transaction: getTransactionAnalytics(checkoutAnalytics) }),
});

export const trackReadAboutEmail = ({ checkoutAnalytics } = {}) => ({
    event: 'learn more about email',
    eventEffect: 'radio button',
    ...(checkoutAnalytics && { transaction: getTransactionAnalytics(checkoutAnalytics) }),
});

export const trackCreateAccount = () => ({
    event: 'sign in - create account',
    effect: 'create account button',
});
